/** Six stable public slots. Profiles remain private AI-service data. */
export const LIVE_NPC_SLOT_IDS = Object.freeze(["LIVE_GAME_NPC_01", "LIVE_GAME_NPC_02", "LIVE_GAME_NPC_03", "LIVE_GAME_NPC_04", "LIVE_GAME_NPC_05", "LIVE_GAME_NPC_06"]);
/** Original homes stay 39 m from start; four additional safe anchors invite exploration. */
export const LIVE_NPC_SPATIAL_DEFAULTS = Object.freeze({
    homes: Object.freeze([
        Object.freeze({ x: 36, z: 27 }), Object.freeze({ x: -36, z: 27 }),
        Object.freeze({ x: 20, z: 65 }), Object.freeze({ x: -55, z: -25 }),
        Object.freeze({ x: 70, z: -20 }), Object.freeze({ x: -20, z: 90 }),
    ]),
    roamRadiusMeters: 30,
});
export const LIVE_NPC_CONFIG = Object.freeze({
    slotCount: 6, interestRadius: 164, conversationRange: 5, conversationEndRange: 7,
    activeBudgetMs: 30_000, maximumPlayerMessages: 10, finalReplyGraceMs: 5_000,
    generationTimeoutMs: 30_000, maximumQueueWaitMs: 70_000, reuseCooldownMs: 60_000,
    maximumMessageChars: 300, maximumMessageBytes: 1_200, hourlyMessageLimit: 60,
    maximumPendingJobs: 8, maximumAbuseEntries: 8_192,
    walkSpeed: 1.8, turnSpeed: 2.5, detectionRange: 26, approachRange: 18,
    approachStopDistance: 4, maximumApproachMs: 12_000, senseIntervalMs: 500,
    minimumRoamRadius: 10, maximumRoamRadius: 80, maximumSafeHomeCorrection: 20, waypointAttempts: 16,
    proactiveCooldownMs: 30_000, globalProactiveCooldownMs: 30_000, samePlayerProactiveCooldownMs: 90_000,
    captionDurationMs: 8_000, maximumReplyChars: 4_000,
});
export function isLiveNpcSlotId(value) {
    return LIVE_NPC_SLOT_IDS.some((id) => id === value);
}
export function isNpcMessageText(value) {
    return typeof value === "string" && value.trim().length > 0
        && value.length <= LIVE_NPC_CONFIG.maximumMessageChars
        && new TextEncoder().encode(value).byteLength <= LIVE_NPC_CONFIG.maximumMessageBytes
        && !/[\u0000-\u001f\u007f-\u009f\u200b-\u200f\u202a-\u202e\u2060-\u206f]/u.test(value);
}
export function isClientNpcMessage(value) {
    if (!value || typeof value !== "object" || Array.isArray(value))
        return false;
    const row = value;
    const keys = (...expected) => Object.keys(row).length === expected.length && expected.every((key) => Object.hasOwn(row, key));
    const id = (input) => typeof input === "string" && /^[A-Za-z0-9_-]{1,80}$/.test(input);
    if (row.t === "npc_start")
        return keys("t", "slotId") && isLiveNpcSlotId(row.slotId);
    if (row.t === "npc_close")
        return keys("t", "encounterId") && id(row.encounterId);
    return row.t === "npc_message" && keys("t", "encounterId", "requestId", "text") && id(row.encounterId) && id(row.requestId) && isNpcMessageText(row.text);
}
